export enum OrderAvailabilityPeriod {
  AM = "am",
  PM = "pm",
}
